import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: function () {
      return import(/* webpackChunkName: "admin" */ '../views/AdminView.vue')
    },
    beforeEnter: requireAdminAuth
  },
  {
    path: '/document/:id',
    name: 'document-detail',
    component: function () {
      return import(/* webpackChunkName: "document-detail" */ '../views/DocumentDetailView.vue')
    },
    beforeEnter: requireAdminAuth
  },
  {
    path: '/player/:docId',
    name: 'player',
    component: function () {
      return import(/* webpackChunkName: "player" */ '../views/PlayerView.vue')
    }
  },
  {
    path: '/target/:docId',
    name: 'target',
    component: function () {
      return import(/* webpackChunkName: "target" */ '../views/Target.vue')
    },
    beforeEnter: requireAdminAuth
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const adminUid = '4JNAQxkPnWaxwQ4i6eDjct5aZHd2'

function requireAdminAuth(to, from, next) {
  const auth = getAuth()
  const user = auth.currentUser
  if (user && user.uid === adminUid && !user.isAnonymous) {
    next()
  } else {
    onAuthStateChanged(auth, (user) => {
      if (user && user.uid === adminUid && !user.isAnonymous) {
        next()
      } else {
        next({ path: '/login', query: { redirect: to.fullPath } })
      }
    })
  }
}

export default router
